import script from "./BodyTopMainSlogan.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyTopMainSlogan.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodyTopMainSlogan.vue?vue&type=style&index=0&id=3c5d55a3&module=bodyTopMainSlogan&lang=css"
cssModules["bodyTopMainSlogan"] = style0
import "./BodyTopMainSlogan.vue?vue&type=style&index=1&id=3c5d55a3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-3c5d55a3"]])

export default __exports__